module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "homepage"
  }, [_vm._m(0), " ", _h('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/experience"
    }
  }, ["Incarner une mère"]), " ", _h('p', {
    staticClass: "description"
  }, ["Lors de cette expérience, vous allez vivre le rôle d'une mère.\n  "])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('h1', ["MAGNA", _h('br'), "MATER"])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f9bf39d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Homepage.vue
// module id = 59
// module chunks = 1